<select class="cmnh-select language-select" name="languageValue" [(ngModel)]="languageValue"
  (ngModelChange)="languageChangedFromDropDown()" required>
  @for (ctype of languages; track ctype) {
  <option class="cmnh-select-option" [ngValue]="ctype.value">
    {{ ctype.label }}
  </option>
  }
</select>
